import { apiClient } from "@/services/api";
import { useQuery } from "@tanstack/react-query";

// Query keys — exported factory (check:query-keys bans literal arrays).
export const dataHealthKeys = {
  all: ["data-health"] as const,
  report: () => [...dataHealthKeys.all, "report"] as const,
};

/** Computed data-health report (§7.1 balance checks + §7.2 lint). Read-only
 * surface: every suggested fix lives in an existing surface, so there is
 * nothing here to invalidate on mutation — a refetch re-runs the checks. */
export function useDataHealthReport() {
  return useQuery({
    queryKey: dataHealthKeys.report(),
    queryFn: () => apiClient.getDataHealthReport(),
  });
}
